<template>
  <div>
    <div v-if="!edit">
      <b>{{ taskModel.task }}</b>
    </div>
    <div v-else>
      <task-finder
        :selectedId="selectedId"
        @on-task-selected="taskSelected($event)"
        :objectTypeId.sync="objectTypeId"
      ></task-finder>
    </div>
  </div>
</template>

<script>
import AsyncLoadError from "@/components/base/asyncLoadingError";
import AsyncLoading from "@/components/base/asyncLoading";

import { request } from "@/api/all";
import { hasOneOf } from "@/libs/tools";
export default {
  name: "vetClientUserOrgSelecter",

  components: {
    taskFinder: () => ({
      component: import("@/components/task/edit/components/taskFinder"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    })
  },
  props: {
    selectedId: {
      type: Number,
      default: () => null
    }
  },
  data: () => ({
    id: 0,
    taskModel: {
      task: ""
    },
    edit: false,
    objectTypeId: "154"
  }),
  mounted() {
    if (!this.hasPermission(["crmlicenseacceptor"])) {
      this.id = this.$store.state.user.userInfo.defaultTasks.organizationTaskId;

      if (this.id != null) {
        request({
          params: { id: this.id },
          api: { url: "task/getInherited", method: "get" },
          store: this.$store
        }).then(res => {
          if (res != false) {
            this.taskModel = res.data.task;
          }
        });
      }

      this.$emit("input", this.id);
    } else {
      this.edit = true;
    }
  },
  methods: {
    hasPermission(perrArr) {
      return hasOneOf(perrArr, this.$store.state.user.access);
    },
    taskSelected(e) {
      this.$emit("input", e.id);
    }
  }
};
</script>
